import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffectOnce, useUnmount } from 'react-use';
import { TimelineComponent } from './timelineComponent/timelineComponent';
import './../styles/timeline.less';
export const Timeline = ({ requesterId, timelineData, currentConversationId, getTimeline, wsRequest, timelineClear, }) => {
    const navigate = useNavigate();
    useEffectOnce(() => {
        wsRequest({
            type: 'connection:subscribe',
            params: {
                type: 'conversation_events',
                events: ['closed', 'pending', 'opened'],
            },
        }).catch((exception) => {
            console.error(exception);
        });
        return () => {
            wsRequest({
                type: 'connection:unsubscribe',
                params: {
                    type: 'conversation_events',
                    events: ['closed', 'pending', 'opened'],
                },
            });
        };
    });
    useUnmount(() => {
        timelineClear();
    });
    useEffect(() => {
        if (requesterId) {
            getTimeline({ requesterId });
        }
    }, [getTimeline, requesterId]);
    const handleConversationSelection = (csid) => {
        navigate(`/conversation/${csid}`);
    };
    if (!timelineData)
        return null;
    return (_jsx(TimelineComponent, { className: "timelinetest", items: timelineData.conversationsByDate, startDate: timelineData.dateFirstConversation, endDate: timelineData.dateLastConversation, onConversationSelect: handleConversationSelection, currentConversation: currentConversationId }));
};
